import { render, staticRenderFns } from "./MomentoContableView.vue?vue&type=template&id=2df25522&"
import script from "./MomentoContableView.vue?vue&type=script&lang=js&"
export * from "./MomentoContableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports